"use client";

import { AppPageTitle } from "@/widgets";
import AiDataSection from "@/widgets/app/page/aidata/AiDataSection";
import { SsgoiTransition } from "@ssgoi/react";

export default function AiDataPage() {
  return (
    <SsgoiTransition id="/app/pages/aidata">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <AiDataSection />
    </SsgoiTransition>
  );
}
